import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BASE_URL = 'http://localhost:8000/api/';

const PurchaseOrderList = () => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch purchase orders from API
    useEffect(() => {
        fetch(`${BASE_URL}purcheshorder`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setPurchaseOrders(data.data);
                    setFilteredOrders(data.data);
                }
            })
            .catch(error => console.error('Error fetching purchase orders:', error));
    }, []);

    // Handle search
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        const filtered = purchaseOrders.filter(order =>
            Object.values(order).some(value =>
                value.toString().toLowerCase().includes(term.toLowerCase())
            )
        );
        setFilteredOrders(filtered);
    };

    // Navigate to edit page
    const handleEdit = (id) => {
        navigate(`/EditPurchaseOrder/${id}`);
    };

    // Delete purchase order
    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this purchase order?')) {
            fetch(`${BASE_URL}purcheshorder/${id}`, {
                method: 'DELETE',
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        setPurchaseOrders(purchaseOrders.filter(order => order.id !== id));
                        setFilteredOrders(filteredOrders.filter(order => order.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting purchase order:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Purchase Order List</h3>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <div className="col-md-6 text-end">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => navigate('/AddPurchaseOrder')}
                                >
                                    Add Purchase Order
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Pack Unit</th>
                                        <th>Pack Quantity</th>
                                        <th>Unit</th>
                                        <th>Quantity</th>
                                        <th>Free Quantity</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                        <th>Discount</th>
                                        <th>Tax Code</th>
                                        <th>Tax Rate</th>
                                        <th>Taxable</th>
                                        <th>Tax Amount</th>
                                        <th>Cess Rate</th>
                                        <th>Cess Amount</th>
                                        <th>MRP</th>
                                        <th>Net Rate</th>
                                        <th>Remarks</th>
                                        <th>Item Barcode</th>
                                        <th>Req VNO</th>
                                        <th>Req Ref No</th>
                                        <th>Req Ref Date</th>
                                        <th>Req Vdate</th>
                                        <th>Item Balance</th>
                                        <th>Barcode</th>
                                        <th>Line Level Barcode</th>
                                        <th>LGST</th>
                                        <th>CGST</th>
                                        <th>SGST</th>
                                        <th>HSN Code</th>
                                        <th>Brand</th>
                                        <th>Created At</th>
                                        <th className="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredOrders.length > 0 ? (
                                        filteredOrders.map(order => (
                                            <tr key={order.id}>
                                                <td>{order.id}</td>
                                                <td>{order.pack_unit}</td>
                                                <td>{order.pack_qty}</td>
                                                <td>{order.unit}</td>
                                                <td>{order.quantity}</td>
                                                <td>{order.free_quantity}</td>
                                                <td>{order.rate}</td>
                                                <td>{order.amount}</td>
                                                <td>{order.discount}</td>
                                                <td>{order.tax_code}</td>
                                                <td>{order.tax_rate}</td>
                                                <td>{order.taxable}</td>
                                                <td>{order.tax_amount}</td>
                                                <td>{order.cess_rate}</td>
                                                <td>{order.cess_amount}</td>
                                                <td>{order.mrp}</td>
                                                <td>{order.net_rate}</td>
                                                <td>{order.remarks}</td>
                                                <td>{order.item_barcode}</td>
                                                <td>{order.req_vno}</td>
                                                <td>{order.req_ref_no}</td>
                                                <td>{new Date(order.req_ref_date).toLocaleDateString()}</td>
                                                <td>{new Date(order.req_vdate).toLocaleDateString()}</td>
                                                <td>{order.item_balance}</td>
                                                <td>{order.barcode}</td>
                                                <td>{order.line_level_barcode}</td>
                                                <td>{order.lgst}</td>
                                                <td>{order.cgst}</td>
                                                <td>{order.sgst}</td>
                                                <td>{order.hsn_code}</td>
                                                <td>{order.brand}</td>
                                                <td>{new Date(order.created_at).toLocaleString()}</td>
                                                <td className="text-end">
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={() => handleEdit(order.id)}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="btn btn-danger ms-2"
                                                        onClick={() => handleDelete(order.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="33" className="text-center">
                                                No Purchase Orders Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PurchaseOrderList;
